export default "__VITE_ASSET__CEdhW15h__"